import { user } from '@/api/auth';
import * as types from './types'

const state = {
  user: null,
  ready: false,
};

const getters = {
  user: (state) => state.user,
  ready: (state) => state.ready,
};

const actions = {
  async fetch({ commit }) {
    try {
      commit(types.FETCHED, await user());
    } catch (e) {
      console.log(e);
    } finally {
      commit(types.READY);
    }
  },
};

const mutations = {
  [types.FETCHED](state, user) {
    state.user = user;
  },
  reset(state) {
    state.user = null;
  },
  [types.READY](state) {
    state.ready = true;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
